import React from 'react'

export default function Header() {




  return (
    <div className='.container' id='header_container'>
        <h1 id='header_title'>Health Hack</h1>
        <hr id='header_divider'></hr>
        

{/*
        <ul id='sub_header_element'>
            <li>Home</li>
            <li>Community</li>
            <li>Docs</li>
            <li>Ressources</li>
        </ul>

        */}


       
        </div>
  )
}
